import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

//创建基本状态
const state={
    loginInfo:{
      member_mobile:"",
      password:""
    }
}
//创建改变状态的方法
const mutations={
    addInfo(state,loginInfo){
      state.loginInfo = loginInfo;
    }

}

//-----------------------------
//获取store里面的状态
const getters={
  // getStorage: function(state) {
  //     if(state.token!='') {
  //         state.loginInfo = JSON.parse(localStorage.getItem(key));
  //     }
  //     return state.loginInfo
  // }
}

//创建驱动actions可以使得mutations得以启动
const actions={
    tokenAction:function(context,obj){
      context.commit("add", obj);
    }
}
//-----------------------------

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js